(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-quote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('press-quotes')) {
    customElements.define(
      'press-quotes',
      class PressQuotes extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-quote-index]'));
          this.quotes = Array.from(this.querySelectorAll('.press-quote__quote'));
          this.index = 0;
          this.buttons.forEach((button) =>
            button.addEventListener('click', () => {
              this.show(Number(button.dataset.quoteIndex));
              this.stop();
            })
          );
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.autoplay === 'true' && !reduced && this.quotes.length > 1) {
            this.timer = setInterval(() => this.show((this.index + 1) % this.quotes.length), 6000);
            this.addEventListener('mouseenter', () => this.stop());
            this.addEventListener('focusin', () => this.stop());
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        stop() {
          clearInterval(this.timer);
          const region = this.querySelector('.press-quote__quotes');
          if (region) region.setAttribute('aria-live', 'polite');
        }

        show(index) {
          this.index = index;
          this.quotes.forEach((quote, i) => {
            quote.hidden = i !== index;
            quote.classList.toggle('is-active', i === index);
          });
          this.buttons.forEach((button, i) => {
            button.classList.toggle('is-active', i === index);
            button.setAttribute('aria-pressed', String(i === index));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
